<template>
  <v-card class="w-100 pa-4" elevation="2" rounded="lg">
    <!-- Section 1 -->
    <div class="mb-4">
      <v-skeleton-loader type="text" :width="getRandomWidth()" class="mb-3" height="24" />
      <v-skeleton-loader type="text" width="100%" class="mb-2" height="24" />
      <v-skeleton-loader type="text" width="100%" class="mb-2" height="24" />
      <v-skeleton-loader type="text" :width="getRandomWidth()" height="24" />
    </div>

    <!-- Section 2 -->
    <div class="mb-4">
      <v-skeleton-loader type="text" :width="getRandomWidth()" class="mb-3" height="24" />
      <v-skeleton-loader type="text" width="100%" class="mb-2" height="24" />
      <v-skeleton-loader type="text" width="100%" class="mb-2" height="24" />
      <v-skeleton-loader type="text" :width="getRandomWidth()" height="12" />
    </div>
  </v-card>
</template>

<script setup lang="ts">
// No script needed for static skeleton
const getRandomWidth = () => {
  let width = Math.round(Math.random() * 100)

  if (width < 30) {
    width += 20
  }

  return `${width}%`
}
</script>

<style scoped>
/* Add any custom styling if needed */
</style>
